import { render } from "./OrderItems.vue?vue&type=template&id=3a6ede86&scoped=true&ts=true"
import script from "./OrderItems.vue?vue&type=script&lang=ts"
export * from "./OrderItems.vue?vue&type=script&lang=ts"

import "./OrderItems.vue?vue&type=style&index=0&id=3a6ede86&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6ede86"]])

export default __exports__